import NoSleep from "nosleep.js"

/**
 *
 * @type {HybirdProvide[]}
 * @private
 */
const _hybirdFns = [];
const createHybird = () => {
  if (_hybirdFns.length > 0) {
    _hybirdFns.sort((o, n) => o.order ? o.order : 50 - n.order ? n.order : 50)

    for (const i in _hybirdFns) {
      const hybirdProvide = _hybirdFns[i];

      if (hybirdProvide.isSupport()) {
        return new hybirdProvide.hybird();
      }
    }
  }

  return new Hybird();
}

/**
 *
 * @param hybirdProvide{HybirdProvide}
 */
const pushHybird = (hybirdProvide) => {
  _hybirdFns.push(hybirdProvide);
}

class Hybird {

  /**
   * 开启屏幕常量
   * @param params{{keepScreenOn: Boolean}} keepScreenOn 是否开启
   * @return {Promise<Boolean>} 开启是否成功
   */
  setKeepScreenOn(params) {
    if (!this.noSleep) {
      this.noSleep = new NoSleep();
    }

    return params.keepScreenOn ? this.noSleep.enable() : this.noSleep.disable();
  }
}

class HybirdProvide {
  /**
   * @type{Class<Hybird>}
   */
  hybird;

  /**
   * @type{function():boolean}
   */
  isSupport;

  order = 50;

  constructor(hybird, isSupport, order = 50) {
    this.hybird = hybird;
    this.isSupport = isSupport;
  }
}

console.log("欢迎使用玺得安")
if (!process.env.DEBUG) {
  const log = ()=>{};
  console.trace = log;
  console.log = log;
  console.info = log;
  console.warn = log;
  console.error = log;
}

export {Hybird, createHybird, HybirdProvide, pushHybird};